import { Navigate, Route, Routes } from "react-router";
import { AuthProvider } from "./auth/AuthContext";
import { AuthGuard, GuestGuard } from "./auth/AuthGuard";
import { LoginPage } from "./features/auth/LoginPage";
import { AppShell } from "./features/_layout/AppShell";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { TenantsPage } from "./features/tenants/TenantsPage";
import { TenantDetailPage } from "./features/tenants/TenantDetailPage";
import { MonComptePage } from "./features/account/MonComptePage";
import { LegalPage } from "./features/legal/LegalPage";
import { StatusPage } from "./features/status/StatusPage";
import { AnalyticsPage } from "./features/analytics/AnalyticsPage";
import { SessionsPage } from "./features/sessions/SessionsPage";
import { DemandesServicesPage } from "./features/demandes-services/DemandesServicesPage";
import { HelpAdminPage } from "./features/help/HelpAdminPage";
import { SupportInboxPage } from "./features/support/SupportInboxPage";

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/login"
          element={
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          }
        />
        <Route
          element={
            <AuthGuard>
              <AppShell />
            </AuthGuard>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="/tenants" element={<TenantsPage />} />
          <Route path="/tenants/:id" element={<TenantDetailPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/demandes-services" element={<DemandesServicesPage />} />
          <Route path="/centre-aide" element={<HelpAdminPage />} />
          <Route path="/support" element={<SupportInboxPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/mon-compte" element={<MonComptePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
